import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navber from "../Components/Navber.jsx";
import api from "../Api.js";
import {
  Box,
  TextField,
  Slider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Button,
} from "@mui/material";

function Itinary_page() {
  const [packageItems, setPackageItems] = useState([]);
   const [filteredItems, setFilteredItems] = useState([]);
 
  const navigate = useNavigate();

  // filters state
  const [search, setSearch] = useState("");
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [days, setDays] = useState("");
  const [rating, setRating] = useState("");
  const customer = JSON.parse(localStorage.getItem("customer"));
  console.log("customer", customer);
  const custId = customer?.id;
  useEffect(() => {

    if(!custId){
      navigate("/signup");
    }
    const fetchPackages = async () => {
      try {
        const response = await api.get("/packages");
        if (response?.data?.status === true) {
          setPackageItems(response.data.data);
          setFilteredItems(response.data.data);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchPackages();
  }, []);

  // filter logic
  useEffect(() => {
    let data = [...packageItems];

    if (search) {
      data = data.filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.destination_name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    data = data.filter(
      (item) => item.price >= priceRange[0] && item.price <= priceRange[1]
    );

    if (days) {
      data = data.filter((item) => item.days === parseInt(days));
    }

    if (rating) {
      data = data.filter(
        (item) => (item.rating ? item.rating : 0) >= parseFloat(rating)
      );
    }

    setFilteredItems(data);
  }, [search, priceRange, days, rating, packageItems]);

  // clear filters
  const handleClearFilters = () => {
    setSearch("");
    setPriceRange([0, 50000]);
    setDays("");
    setRating("");
  };

  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />


      </div>
      <div>
                {/* Custom Filter Section */}
        <Box
          className="custom_filter"
          sx={{
            display: "flex",
            gap: 3,
            p: 3,
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            
          }}
        >
          <TextField
            label="Search Destination"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Box sx={{ width: 250 }}>
            <Typography gutterBottom>Price Range</Typography>
            <Slider
              value={priceRange}
              onChange={(e, newValue) => setPriceRange(newValue)}
              valueLabelDisplay="auto"
              min={0}
              max={50000}
            />
          </Box>

          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel>Days</InputLabel>
            <Select
              value={days}
              label="Days"
              onChange={(e) => setDays(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value={3}>3 Days</MenuItem>
              <MenuItem value={6}>6 Days</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel>Rating</InputLabel>
            <Select
              value={rating}
              label="Rating"
              onChange={(e) => setRating(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value={4}>4 ★ & above</MenuItem>
              <MenuItem value={3}>3 ★ & above</MenuItem>
              <MenuItem value={2}>2 ★ & above</MenuItem>
            </Select>
          </FormControl>

          <Button variant="contained" color="secondary" onClick={handleClearFilters}>
            Clear Filters
          </Button>
        </Box>

        {/* Filtered Packages */}
        <Grid
          container
          spacing={3}
          sx={{
            p: 3,
            justifyContent: "center",
          }}
        >
          {filteredItems.map((item) => (
            <Grid
              item
              key={item.id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  width: 300,
                  height: 300,
                  display: "flex",
                  flexDirection: "column",
                  position: "relative", // for hover overlay
                  overflow: "hidden",
                  "&:hover .overlay": {
                    opacity: 1, // show overlay on hover
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="180"
                  image={item.featured_photo}
                  alt={item.name}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" gutterBottom noWrap>
                    {item.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    ₹{item.price}
                  </Typography>
                  <Typography variant="body2">
                    Days: {item.days} | ⭐ {item.rating || "No Rating"}
                  </Typography>
                </CardContent>

                {/* Hover Button Overlay */}
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                  }}
                >


                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ fontWeight: "bold" }}
                    onClick={() => navigate(`/packages/${item.id}/tour/${item.tour_id}/itinerary/${custId}`)}
                  >
                    View Itinerary
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default Itinary_page;
